import { ReactNode, useEffect } from "react";
import { useAdminDispatch, useAdminSelector } from "../../../stores/AdminStore";
import { setPermissions } from "../../../stores/AuthSlice";
import { useGetMyPermissionsQuery } from "../api/PermissionsApi";
import { Module } from "../../ui/components/Module";
import { Trans } from "react-i18next";

interface AuthorizationGuardProps {
  children?: ReactNode | ReactNode[];
}

export const AuthorizationGuard = ({children}: AuthorizationGuardProps) => {
  const dispatch = useAdminDispatch();
  const {status} = useAdminSelector(s => s.auth);
  const {data, error} = useGetMyPermissionsQuery();

  useEffect(() => {
    if (!data) {
      return;
    }
    dispatch(setPermissions(data));
  }, [data, dispatch]);

  if (error) {
    return (
      <Module>
        <Trans>Critical Error</Trans>
      </Module>
    );
  }

  if (status !== "authorized") {
    return null;
  }

  return (
    <>
      {children}
    </>
  );
};
